import React from 'react';
import { translate } from '../../Services/translation';

const LoaderOverlay = () => (
  <div className="absolute size-full top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center z-10">
    <div className="bg-white size-full absolute opacity-90 -z-1" />
    <div className="flex items-center gap-2 text-accent text-sm font-semibold py-4">
      <span>{translate('general.loading')}</span>
      <span
        className="icon icon-outlined !text-accent !text-sm animate-hourglass-flip"
        aria-hidden="true"
      >
        hourglass
      </span>
    </div>
  </div>
);

export default LoaderOverlay;
